import { getIconForType } from "ioc"
import { BasketIcon } from "routes/schedule/plugins/baskets/tree/basket-icon"

export function getIconForNav(type) {
    const icon = getIconForType(type, <BasketIcon />, {}, false)
    return <icon.type {...icon.props} sx={{ ...icon.sx, color: "inherit" }} />
}
